import React, { useState } from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import AddressesTab from './AddressesTab';
import ContactsTab from './ContactsTab';
import DefaultTemplatesTab from './DefaultTemplatesTab';
import PurchaseByProducts from './PurchaseByProducts';
import PurchaseByDocument from './PurchaseByDocument';
import Attachments from './Attachments';
import ActivityLog from './ActivityLog';

import LocationOnIcon from '@mui/icons-material/LocationOn';
import PersonIcon from '@mui/icons-material/Person';
import DescriptionIcon from '@mui/icons-material/Description';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

const TabsWrapper = ({ isSupplierCreated }) => {
  const [activeTab, setActiveTab] = useState(0);

  const baseTabs = [
    { label: "Addresses", icon: <LocationOnIcon />, component: <AddressesTab /> },
    { label: "Contacts", icon: <PersonIcon />, component: <ContactsTab /> },
    { label: "Default Templates", icon: <DescriptionIcon />, component: <DefaultTemplatesTab /> },
  ];

  const extraTabs = [
    { label: "Purchases by Products", icon: <ShoppingCartIcon />, component: <PurchaseByProducts /> },
    { label: "Purchases by Documents", icon: <ShoppingCartIcon />, component: <PurchaseByDocument /> },
    { label: "Attachment", icon: <AttachFileIcon />, component: <Attachments /> },
    { label: "Activity Log", icon: <AccessTimeIcon />, component: <ActivityLog /> },
  ];

  const allTabs = isSupplierCreated ? [...baseTabs, ...extraTabs] : baseTabs;

  return (
    <Box sx={{ backgroundColor: '#fff', mt: 2, borderRadius: 3 }}>
      <Tabs
        value={activeTab}
        onChange={(e, newValue) => setActiveTab(newValue)}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        sx={{ borderBottom: '1px solid black' }}
      >
        {allTabs.map((tab, index) => (
          <Tab
            key={index}
            icon={tab.icon}
            iconPosition="start"
            label={tab.label}
            sx={{ whiteSpace: 'nowrap', minWidth: 'auto' }}
          />
        ))}
      </Tabs>

      <Box sx={{ mt: 3, px: 1, pb: 0.1 }}>
        {allTabs[activeTab]?.component}
      </Box>
    </Box>
  );
};

export default TabsWrapper;
